// removed by extract-text-webpack-plugin
module.exports = {"carouselImages":"qempo_CarouselPressNew_carouselImages-21rmuTA","carousel":"qempo_CarouselPressNew_carousel-3gDcWIW","arrowLeft":"qempo_CarouselPressNew_arrowLeft-34Mrfoa","arrowRight":"qempo_CarouselPressNew_arrowRight-22oNfLQ"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/home/components/CarouselPressNew/CarouselPressNew.scss
// module id = 1190
// module chunks = 0